import { render, staticRenderFns } from "./InfoRecipe.vue?vue&type=template&id=6023695b&scoped=true"
import script from "./InfoRecipe.vue?vue&type=script&lang=js"
export * from "./InfoRecipe.vue?vue&type=script&lang=js"
import style0 from "./InfoRecipe.vue?vue&type=style&index=0&id=6023695b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6023695b",
  null
  
)

export default component.exports